<div class="table-responsive health-check-table">
  <table class="table">
    <thead>
      <th>Health Metrics</th>
      <th>Status</th>
      <th>Value</th>
      <th>Reason</th>
      <th>Recommendation</th>
    </thead>
    <tbody *ngIf="surveyHealths.length; else noSurveyHealths">
      <ng-container *ngFor="let health of surveyHealths">
        <tr>
          <td>
            <label>{{ health.name }}</label>
            <div class="setting-info">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              <p style="white-space: normal" [innerHTML]="health.tooltip"></p>
            </div>
          </td>
          <td>
            <div
              *ngIf="health.status === healthCheckStatus.RED"
              class="poor-data"
            >
              <span class="poor-icon"
                ><i
                  class="fa fa-exclamation-circle"
                  aria-hidden="true"
                ></i></span
              ><span class="poor-text">NEEDS ATTENTION</span>
            </div>
            <div
              *ngIf="health.status === healthCheckStatus.YELLOW"
              class="ok-data"
            >
              <span class="ok-icon"
                ><i
                  class="fa fa-exclamation-triangle"
                  aria-hidden="true"
                ></i></span
              ><span class="ok-text">DECLINING PERFORMANCE</span>
            </div>
            <div
              *ngIf="health.status === healthCheckStatus.GREEN"
              class="good-data"
            >
              <span class="good-icon"
                ><i class="fa fa-check" aria-hidden="true"></i></span
              ><span class="good-text">CURRENTLY HEALTHY</span>
            </div>
            <div
              *ngIf="health.status === healthCheckStatus.GREY"
              class="grey-data"
            >
              <span class="grey-icon"
                ><i class="fa fa-gear" aria-hidden="true"></i></span
              ><span class="grey-text">COLLECTING DATA</span>
            </div>
          </td>
          <td>{{ health.value }}</td>
          <td>
            <span *ngIf="![healthCheckStatus.GREEN].includes(health.status)"
              >{{ health.reasonMsg }}
              {{
                (health.nextCalculationTs | date : 'MM/dd/yyyy h:mma') || ''
              }}</span
            >
          </td>
          <td>
            <ng-container *ngIf="health.status === healthCheckStatus.RED">
              <ul>
                <li *ngFor="let msg of health.rRecommendationMsg">{{ msg }}</li>
              </ul>
            </ng-container>
            <ng-container *ngIf="health.status === healthCheckStatus.YELLOW">
              <ul>
                <li *ngFor="let msg of health.yRecommendationMsg">{{ msg }}</li>
              </ul>
            </ng-container>
            <span *ngIf="health.status === healthCheckStatus.GREEN"></span>
            <span *ngIf="health.status === healthCheckStatus.GREY"></span>
          </td>
        </tr>
      </ng-container>
    </tbody>
    <ng-template #noSurveyHealths>
      <tbody>
        <tr>
          <td colspan="5" class="no-data">
            <p class="m-0">
              Health Check config was disabled while creating this survey.<br />So,
              Health Check Metrics are not availble for this.
            </p>
          </td>
        </tr>
      </tbody>
    </ng-template>
  </table>
</div>
